import { ColorOptions, ModBox, TextNew } from '@jfs/ui-new'
import { TextInputNew } from '../../../components/AdminInputs'
import { Dropdown } from '../../../components/Dropdown'

const ConfigItem = ({ title, key, value, status, label, isEdit = false }: any) => {
  const onDropDownChange = (selectedData: any) => {
    console.log('ConfigItem :', selectedData, key, status)
  }
  return (
    <ModBox w={'49%'} h={132} borderWidth={1} borderRadius={4} borderColor={'#E0E0E0' as ColorOptions} margin={4}>
      <ModBox
        backgroundColor={'#F8F8F8' as ColorOptions}
        h={42}
        direction="row"
        alignItems={'center'}
        justifyContent={'flex-start'}
        paddingLeft={16}
        borderBottomWidth={1}
        borderBottomColor={'#E0E0E0' as ColorOptions}>
        <TextNew title="ConfigType: " color={'BLACK_21'} fontSize={12} fontFamily="jiotype-bold" />
        <TextNew title={title} color={'BLACK_21'} fontSize={12} fontFamily="jiotype-bold" />
      </ModBox>
      <ModBox h={90} direction="row" w={'100%'} alignItems={'center'} justifyContent={'space-between'} paddingLeft={16}>
        <ModBox paddingBottom={16} h={60}>
          <TextInputNew
            label={label}
            type="body12"
            borderColor={isEdit ? ('#d1d3e2' as ColorOptions) : 'WHITE'}
            labelPaddingBottom={10}
            borderRadius={isEdit ? 4 : 0}
            labelFontFamily={'jiotype-medium'}
            labelColor={'#757575' as ColorOptions}
            fontSize={12}
            selectionColor={isEdit ? 'BLUE' : 'TRANSPARENT'}
            paddingVertical={isEdit ? 8 : 0}
            paddingHorizontal={isEdit ? 8 : 0}
            color={'BLACK_21' as ColorOptions}
            onFocusBorderWidth={isEdit ? 1 : 0}
            editable={isEdit}
            value={value}
          />
        </ModBox>
        <ModBox show={isEdit} w={164} paddingRight={28} paddingBottom={16}>
          <Dropdown
            label={'Status'}
            title={isEdit ? 'Select' : undefined}
            data={[
              { id: '1', value: 'Active' },
              { id: '2', value: 'In Active' },
            ]}
            type={'default'}
            selectedData={onDropDownChange}
          />
        </ModBox>
        <ModBox show={!isEdit} w={164} paddingRight={28} paddingBottom={16}>
          <TextInputNew
            label={'Status'}
            type="body12"
            borderColor={'WHITE'}
            labelPaddingBottom={10}
            borderRadius={0}
            labelFontFamily={'jiotype-medium'}
            labelColor={'#757575' as ColorOptions}
            fontSize={12}
            selectionColor={'TRANSPARENT'}
            color={status && status?.toLowerCase() === 'active' ? 'GREEN' : ('BLACK_21' as ColorOptions)}
            onFocusBorderWidth={0}
            editable={false}
            value={status}
          />
        </ModBox>
      </ModBox>
    </ModBox>
  )
}

export { ConfigItem }
